// Re-export from pe-core-frontend for backwards compatibility
export { SUPPORTED_LOCALES as LANGUAGE_OPTIONS } from 'pe-core-frontend';
export const PERSIST_LANGUAGE_PREFERENCE_URL = 'https://persist-language-preference.guildeducation.com';
export const LANGUAGE_IMAGE_PATH = 'https://guild.imgix.net/language-preference';
